import Vue from 'vue';
import router from '@/router';

export default Vue.directive('app-back-button', {
  bind: (el, { value }) => {
    if (value) el.addEventListener('click', () => router.push(value));
    else el.addEventListener('click', () => history.back());
  },
});
